import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core'
import HMapContainerArrow from './HMapContainerArrow'
import HMapContainerPin from './HMapContainerPin'
import HMapContainerStar from './HMapContainerStar'
import HMapThreeDots from './HMapThreeDots'
import Radio from '@mui/material/Radio'
import { useHMapContext } from '../hooks/useHMapContext'
import { ResizableLoader } from '../../../components/1elements'

const HMapCollapsableContainer = ({
  children,
  id,
  name,
  pin,
  star,
  type,
  setCurrentPanel,
  allHeatMaps,
  setAllHeatMaps
}) => {
  const [open, setOpen] = useState(false)
  const [showLoader, setShowLoader] = useState(false)
  const classes = useStyles()
  const { currentMapInfo } = useHMapContext()
  const [currentMap, , handleCurrentMapChange] = currentMapInfo

  useEffect(() => setOpen(false), [id])

  return (
    <div className={classes.root}>
      {showLoader ? (
        <div className={classes.headerWrapper}>
          <div className={classes.loadingContent}>
            <ResizableLoader
              image={{height: '20px'}}
              circle={{top: '-15px', left: '-18px', size: 50}}
            />
          </div>
        </div>
      ) : (
        <>
          <div className={classes.headerWrapper}>
            <div className={classes.left}>
              {/* Arrow Icon */}
              <HMapContainerArrow toggle={open} setToggle={setOpen} />
              {/* Text */}
              <div className={classes.headerText}>{name}</div>
            </div>
            <div className={classes.right}>
              {/* Pin */}
              <HMapContainerPin
                id={id}
                name={name}
                pin={pin}
                allHeatMaps={allHeatMaps}
                setAllHeatMaps={setAllHeatMaps}
                type={type}
                setShowLoader={setShowLoader}
              />
              {/* Star */}
              <HMapContainerStar
                id={id}
                name={name}
                star={star}
                allHeatMaps={allHeatMaps}
                setAllHeatMaps={setAllHeatMaps}
                type={type}
                setShowLoader={setShowLoader}
              />
              {/* Radio Button */}
              <Radio
                style={{ padding: '3px' }}
                className={classes.radioButton}
                id={`${id}`}
                name={`${name}`}
                pin={`${pin}`}
                star={`${star}`}
                value={`${id}`}
                checked={currentMap === id}
                onChange={handleCurrentMapChange}
              />
              {/* 3 dot Menu */}
              <HMapThreeDots
                id={id}
                name={name}
                type={type}
                allHeatMaps={allHeatMaps}
                setAllHeatMaps={setAllHeatMaps}
                setCurrentPanel={setCurrentPanel}
              />
            </div>
          </div>
          {open && <div className={classes.contentWrapper}>{children}</div>}
        </>
      )}
    </div>
  )
}

export default React.memo(HMapCollapsableContainer)

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center'
  },
  loadingContent: {
    width: '100%',
    height: '60px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center'
  },
  headerWrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: '4px 0',
    borderBottom: `1px solid ${theme.palette.secondary.main}`
  },
  left: {
    width: '60%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  right: {
    width: '40%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  headerText: {
    ...theme.typography.h12,
    color: theme.palette.tertiary.main
  },
  contentWrapper: {
    width: '100%',
    borderBottom: `1px solid ${theme.palette.secondary.main}`
  },
  radioButton: {
    '& .MuiSvgIcon-root': {
      fontSize: 17
    },
    color: theme.palette.primary.accent,
    '&.Mui-checked': {
      color: theme.palette.primary.accent
    }
  }
}))
